import { IBusinessCorrespondence, IBusinessFollowUpSiteVisit, IBusinessInitialSiteVisit } from "../business/business";
import { IComplaint, IComplaintAction, ICorrespondence, IInitialComplaint } from "../complaints/complaints";


export interface ISelectItems {
  text: string; 
  value: string;
}

export interface ISelectGroup{
  disabled: boolean;
  name: string;
}

export interface IReportSelectItems {
  text: string;
  selected: boolean;
  disabled: boolean;
  value: string;
  group: ISelectGroup;
}

export interface IActionLkp{
  actionId: number;
  description: string;

  complaintAction: IComplaintAction;
}

export interface ICorrTypeLkp{
  corrTypeId: number;
  description: string;
  isActive: boolean;

  businessCorrespondence: IBusinessCorrespondence;
  correspondence: ICorrespondence;
  letterTemplate: ILetterTemplate;
}

export interface ILetterTemplate{
  letterId: number;
  countyId: number;
  title: string;
  text: string;
  countyImage: string;
  active: boolean;
  corrTypeId: number;
  businessOnly: boolean;

  corrType: ICorrTypeLkp;
}

export interface INotes{
  notesId: number;
  complaintId: number;
  timeStamp: Date;
  noteType: string;
  notes1: string;
  loggedUser: string;

  complaint: IComplaint;
}

export interface IUploads{
  uploadId: number;
  initialComplaintId: number;
  complaintId: number;
  contentType: string;
  extension: string;
  uploadFile: Blob;
  name: string;
  description: string;
  dateTime: Date;
  uploadedByStaff: boolean;
  staffName: string;

  complaint: IComplaint;
  initialComplaint: IInitialComplaint;
}

export interface ISiteVisitConductedLkp{
  
  niteVisitNotConductedId: number;
  description: string;

  businessFollowUpSiteVisit: IBusinessFollowUpSiteVisit;
  businessInitialSiteVisit: IBusinessInitialSiteVisit;
}

